<script setup lang="ts">
    import { computed } from 'vue';

    const props = withDefaults(
        defineProps<{
            variant?: 'default' | 'solid' | 'light' | 'success' | 'error';
        }>(),
        {
            variant: 'default',
        }
    );

    const labelClass = computed(() => {
        return `Echo-label Echo-label--${props.variant}`;
    });
</script>

<template>
    <div :class="labelClass">
        <slot />
    </div>
</template>
